import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import WatchStatisticsService from "@/views/sidebar/watch-statistics/watch-statistics.service";
import { 
  WatchCharging,
  WatchWorn,
  BiometricCollectionCount,
  Imei,
  WatchAssignment
} from "@/views/sidebar/watch-statistics/watch-statistics.types";

@Module({ namespaced: true })
class WatchStatistics extends VuexModule {
  imeis: Imei[] = [];

  watchWorn = new WatchWorn();
  watchCharging = new WatchCharging();
  biometricRecordCount = new BiometricCollectionCount();

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchActiveImeis(clientId: number) {
    const imeis = await WatchStatisticsService.GetActiveImeis(clientId);
    this.context.commit("updateField", {
      path: "imeis",
      value: imeis
    });
  }

  @Action({ rawError: true })
  async fetchWatchWorn({ date, clientId, participantId, timezone }: { date: string, clientId: number, participantId: number, timezone: string }) {
    const watchWorn = await WatchStatisticsService.GetWatchWorn(clientId, date, participantId, timezone);
    this.watchWorn.am = [...watchWorn.am];
    this.watchWorn.pm = [...watchWorn.pm];
  }
  
  @Action({ rawError: true })
  async fetchWatchCharging({ date, clientId, participantId, timezone }: { date: string, clientId: number, participantId: number, timezone: string }) {
    const watchStats = await WatchStatisticsService.GetWatchCharging(clientId, date, participantId, timezone);
    this.watchCharging.am = [...watchStats.am];
    this.watchCharging.pm = [...watchStats.pm];
  }

  @Action({ rawError: true })
  async fetchBiometricRecordCount({ date, clientId, participantId, timezone }: { date: string, clientId: number, participantId: number, timezone: string }) {
    const biometricRecordCount = await WatchStatisticsService.GetBiometricRecordCount(clientId, date, participantId, timezone);
    this.biometricRecordCount.am = [...biometricRecordCount.am];
    this.biometricRecordCount.pm = [...biometricRecordCount.pm];
  }

  @Action({ rawError: true })
  async upsertParticipantIMEIMap(watchAssignment: WatchAssignment) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      await WatchStatisticsService.UpsertParticipantIMEIMap(watchAssignment);
    } catch (e: any) {
      const errorMessage = e.response?.data || e.response.data.message || "An unexpected error occurred.";
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

WatchStatistics.getters = { getField };
WatchStatistics.mutations = { updateField };

export default WatchStatistics;